import { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TenantContext } from "../../context/tenant/TenantContext";
import DOMPurify from "dompurify";
import { Link, useLocation } from "react-router-dom";
import { LanguageContext } from "../../context/language/LanguageContext";
import "./cookiepolicy.css";

export default function CookiePolicy() {
    const { tenant } = useContext(TenantContext);
    const url = useLocation().pathname.split("/")[1];
    const { language } = useContext(LanguageContext);

    // Default cookie policy content if tenant doesn't have one
    const defaultCookiePolicy = `
        <div class="cookie-policy-content">
             <div class="main-title">Cookie Policy for Suncorp Bank Feel Good Rewards Offers Page</div>

    <!-- opening paragraph -->
    <p>This is the Cookie Policy for Suncorp Bank Feel Good Rewards Offers, accessible from 
        <a href="https://www.offers-exchange.com/feelgoodrewards" class="link">https://www.offers-exchange.com/feelgoodrewards</a> 
        (the "<span class="bold">website</span>"). Suncorp Bank (Norfina Limited ABN 66 010 831 722 AFSL 229882) and its Subsidiaries ("we", "our"), through service providers collect and use data related to your online activity using cookies and other related technologies. This policy provides information about how and why we do this, and how you can choose to browse more privately. Suncorp Bank's "<span class="bold">Subsidiaries</span>" are:
    </p>

    <!-- bullet list subsidiaries -->
    <ul class="bullet-list">
        <li>Suncorp Equipment Finance (Norfina Advances Corporation Pty Ltd (ABN 89 100 845 127)); and</li>
        <li>SME Management Pty Limited (ABN 21 084 490 166).</li>
    </ul>

    <p>The website is managed on behalf of Suncorp Bank by Visa Worldwide Pte Ltd ("Visa") and Pulse Global Limited ("Pulse").</p>

    <!-- WHAT ARE COOKIES -->
    <h2>What Are Cookies</h2>
    <p>There are various technologies that allow tracking of online activity.</p>
    <p>The most commonly used technology is cookies. Cookies are text files containing small amounts of information, which your computer or mobile device creates when you visit a website. When you return to the website, the site can read these text files, and recognise your device, helping to enable site features and functionality.</p>

    <!-- HOW WE USE COOKIES -->
    <h2>How We Use Cookies</h2>
    <p>We use cookies for a variety of reasons detailed below.</p>
    <p>Cookies and related technologies are useful in many ways. They:</p>
    <ul class="bullet-list">
        <li>Provide us with information on how our site is being used,</li>
        <li>Help us to tailor marketing message to your interests, both on and off our sites,</li>
        <li>Let you navigate between pages more quickly and securely,</li>
        <li>Help detect and defend against fraud,</li>
        <li>Recognise you when you return to websites and remember your preferences,</li>
        <li>Assist us with product and service research, development and business strategy, and</li>
        <li>Generally improve your browsing experience.</li>
    </ul>

    <p><span class="bold">Visa and Pulse ID</span> are using Google Analytics to collect information on the website such as time spent browsing offers, on a single offer, number of visitors to the site, etc., on an anonymous basis. Zero personal information is being collected. This information is shared with Suncorp Bank to help build a better consumer experience on the website</p>

    <p>For more information on Google analytics please visit <a href="https://support.google.com/analytics?hl=en&sjid=2690920594829157579-NC#topic=14090456" class="link">https://support.google.com/analytics?hl=en&sjid=2690920594829157579-NC#topic=14090456</a></p>

    <h3>Site Performance Cookies</h3>
    <p>These cookies collect information about how our sites are performing. For example, they tell us which content is popular, or how people are moving around our sites. The information they collect is anonymous and is used to help us improve how the sites work.</p>

    <h3>Preferences Cookies</h3>
    <p>These functional cookies are all about the choices you make both on our sites and our advertising partners' sites. They store information about your choices (such as your language or the region you're in) and tailor your internet experience to provide relevant features and content for you, such as localised information or news. These cookies can also be used to remember changes you've made to text size, font and other customisable content.</p>
    <p>Without these cookies, our website won't remember any choices you've previously made or customise your browsing experience.</p>

    <!-- LEGAL COMPLIANCE -->
    <h2>Legal Compliance and User Consent</h2>
    <p>Visa and Pulse ID comply with relevant data protection laws, including GDPR and CCPA, By using this site, you consent to Visa and Pulse ID's cookie usage as outlined in this policy. GDPR means the General Data Protection Regulation and is a European Union regulation on data protection and privacy for all individuals within the EU. CCPA means the California Consumer Privacy Act signed into law in 2018, which grants California resident's rights to control their personal data. Neither Visa nor Pulse ID are based in Australia and the website is hosted in AWS Singapore.</p>
    <p>Suncorp Bank as an Australian entity is subject to the <span class="italic">Privacy Act 1988</span> (Cth) and where it collects personal information whether through the website or otherwise, it manages that personal information in accordance with its Privacy Policy available at <a href="http://www.suncorpbank.com.au/privacy" class="link">www.suncorpbank.com.au/privacy</a>.</p>

    <!-- DISABLING COOKIES -->
    <h2>Disabling Cookies</h2>
    <p>By changing your browser settings, you can manage how cookies are used on your computer or device. Usually, you can do this by opening the menu in the browser, and choose settings, options or privacy (it depends on which browser you're using). From there, you can tailor how your device stores cookies. Options may include deleting all or some cookies, not accepting any cookies or being notified when cookies are being used. For example, if you are using Google Chrome browser, you can choose to browse "incognito" which will only allow session-based cookies.</p>
    <p>You can delete existing cookies on your device and block new cookies if you don't want your online activity to be tracked and remembered. Perhaps you share a device, and previous online activity is by someone else so not relevant for you, or maybe you don't want to be recognised online or served interest-based advertising. Without cookies, we can't recognise you across visits.</p>

    <!-- COOKIE DURATION -->
    <h2>Cookie Duration</h2>
    <p>The duration for which a cookie is stored on your device depends on its type. Session cookies are temporary and will be deleted automatically when you close your browser. Persistent cookies remain on your device until they expire, or you delete them.</p>

    <h3>Session-based cookies</h3>
    <p>These cookies store temporary information and are usually deleted when you close your browser.</p>

    <h3>Persistent cookies</h3>
    <p>These cookies are stored in your browser for a set amount of time and stay on your computer after you close your browser. They usually contain information you may want to keep from session to session (e.g. your location or username).</p>

    <p>For more information, please visit <a href="http://www.suncorpbank.com.au" class="link">www.suncorpbank.com.au</a></p>
        </div>
    `;

    return (
        <>
            <style>
                {`
                  
                    .main-title {
                        text-decoration: underline;
                        font-size: 16pt;
                        font-weight: bold;
                        margin-bottom: 8px;
                        display: block;
                    }
                    p {
                        margin: 0 0 8px 0;
                    }
                    .bold {
                        font-weight: 600;
                    }
                    .link {
                        color: #0055cc;
                        text-decoration: underline;
                        word-break: break-all;
                    }
                    .bullet-list {
                        margin: 4px 0 12px 20px;
                        padding-left: 0;
                    }
                    .bullet-list li {
                        margin-bottom: 2px;
                    }
                    h2 {
                        font-size: 14pt;
                        font-weight: bold;
                        margin: 20px 0 6px 0;
                    }
                    h3 {
                        font-size: 12pt;
                        font-weight: bold;
                        margin: 16px 0 4px 0;
                    }
                    .subsidiary-block {
                        margin-left: 20px;
                    }
                    .hr-light {
                        border: 0.5px solid #ccc;
                        margin: 20px 0;
                    }
                    .small-note {
                        font-size: 10pt;
                        color: #444;
                    }
                `}
            </style>
            <Container>
            <Row className="">
                <Col className="pt-5">
                    <Link to={`/${url}`} className="text-dark mb-4 d-inline-block" style={{ fontSize: "30px" }}>
                        <i className="bi bi-chevron-left"></i>
                    </Link>
                    {tenant ? (
                        <div>
                            {/* If tenant has cookie policy, show it. Otherwise show default */}
                            <div 
                                className="text-dark" 
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        tenant?.cookiepolicy || defaultCookiePolicy
                                    )
                                }}
                            />
                        </div>
                    ) : (
                        <div>{language?.static_labels?.cookie_policy_not_available || "Cookie policy not available"}</div>
                    )}
                </Col>
            </Row>
        </Container>
        </>
    );
}
